import styled, { css } from 'styled-components';
import { Spacing24 } from 'autogen/design-tokens/tokens';
import Card from 'modules/shared/card';

const ContainerStyling = css`
    margin-bottom: ${Spacing24};
`;

export const Container = styled.div`
    ${ContainerStyling}
`;

export const CardContainer = styled(Card)`
    ${ContainerStyling}
`;
